import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {worldCurrencies} from "../utils/currencies"
import {
  InternationalOperationSummaryService
} from '../../services/international-operation-summary/international-operation-summary.service';
import {
  InternationalPaymentSuccessService
} from '../../services/payments/international/international-payment-success.service';
import {PaymentReasonsService} from "../../services/payments/international/payment-reasons.service";
import moment from 'moment';


@Component({
  selector: 'lib-international-payment',
  templateUrl: './international-payment.component.html',
  styleUrls: ['./international-payment.component.scss']
})
export class InternationalPaymentComponent implements OnInit {

  // @Input() currenciesByContractId: any
  // @Input() receivers: any
  // @Input() paymentReasonsArr: any
  receivers: any = [
    {
      indentificationName: "Alias ruben",
      personName: "Ruben Gallardo test",
      comment: "BBVA",
      beneficiaryAccount: "7845625",
      descriptionCurrency: "DOLAR AMERICANO",
      currency: "USD"
    },
    {
      indentificationName: "Alias ruben",
      personName: "Ruben Gallardo test",
      comment: "BBVA",
      beneficiaryAccount: "7845625",
      descriptionCurrency: "LIBRA ESTERLINA",
      currency: "GBP"
    }
  ]
  internationalPaymentForm: any
  filteredNames: any;
  inputReceiverValue: any = "input receiver value"
  titleReceiver: any;
  currencySelected: any;
  importeNeto: number = 0;
  iva: number = 0;
  commission: number = 0;
  commissionChargeArr: any = [
    {
      key: 1,
      value: "Quiero absorber el cargo"
    },
    {
      key: 2,
      value: "Quiero compartir el cargo con el destinatario"
    },
  ]
  paymentReasonsArr: any = [
    {
      "code": "NM1",
      "description": "APORTACIONES O AUMENTO DE CAPITAL"
    },
    {
      "code": "NM10",
      "description": "ENVIO DE FONDOS A EMPRESAS DEL MISMO GRUPO"
    },
    {
      "code": "NM11",
      "description": "ENVIO DE FONDOS PARA AHORRO/INVERSION"
    },
    {
      "code": "NM12",
      "description": "IMPUESTOS Y CONTRIBUCIONESFISCALES"
    },
  ]
  currenciesByContractId: any = [
    {
      balance: "-230",
      cveCurrency: "USD"
    },
    {
      balance: "900000",
      cveCurrency: "MXP"
    },
    {
      balance: "556000",
      cveCurrency: "GBP"
    }
  ]

  minDate: any = moment().toDate()
  loadingContracts: boolean = false;
  loadingBalances: boolean = false;
  amountExceeded: boolean = false;
  hideImporteNeto: boolean = false;
  loadingCommission: boolean = false

  @ViewChild('receiverInput', {static: false}) receiverInput!: any;

  constructor(
    private formBuilder: FormBuilder,
    private internationalOperationSummaryService: InternationalOperationSummaryService,
    private internationalPaymentSuccess: InternationalPaymentSuccessService,
    private paymentReasonsService: PaymentReasonsService
  ) {
  }

  ngOnInit(): void {
    // this.internationalPaymentSuccess.open({
    //   amount: "$ 200 MXP",
    //   commission: "$ 0.00 MXP",
    //   receiver: "Ruben Dario gallardo",
    //   bank: "BBVA",
    //   account: "4568778987",
    //   receiverInformation: "Informacion importante"
    // })
    this.loadersTest()
    this.buildForm()
    this.internationalPaymentForm.patchValue({
      receiverSelected: this.receivers
    });
    this.getPaymentsReasons();

  }

  getPaymentsReasons() {
    console.log('getPaymentsReasons');
    this.paymentReasonsService.getPaymentsReasons().subscribe({
      next: reasons => {

      },
      error: err => {

      }
    })
  }


  buildForm() {
    this.internationalPaymentForm = this.formBuilder.group({
      receiverSelected: [this.internationalPaymentForm?.selectedName ? this.internationalPaymentForm?.selectedName : null, [Validators.required]],
      commissionCharge: [this.internationalPaymentForm?.commissionCharge ? this.internationalPaymentForm?.commissionCharge : null, [Validators.required]],
      paymentReason: [this.internationalPaymentForm?.paymentReason ? this.internationalPaymentForm?.paymentReason : null, [Validators.required]],
      receiverInformation: [this.internationalPaymentForm?.receiverInformation ? this.internationalPaymentForm?.receiverInformation : null, [Validators.required]],
      amount: [this.internationalPaymentForm?.amount ? this.internationalPaymentForm?.amount : null, [Validators.required]],
      schedulePayment: [this.internationalPaymentForm?.schedulePayment ? this.internationalPaymentForm?.schedulePayment : false],
      date: [this.internationalPaymentForm?.date ? this.internationalPaymentForm?.date : ""],
    })

    this.internationalPaymentForm.get('amount').valueChanges.subscribe((amountInput: any) => {
      // this.getCommisionAndIva()
      this.importeNeto = amountInput /* + this.commission + this.iva; */
      console.log(this.importeNeto)
      this.calculateTotal();
      this.validateSubmitButton()
    });
  }

  limpiarInput() {
    if (this.receiverInput) {
      this.receiverInput.value = '';
      this.internationalPaymentForm.get("receiverSelected").setValue(null)
    }
  }

  clearInputReceiver() {
    this.inputReceiverValue = ""
    this.hideImporteNeto = false
    this.loadingCommission = false
    // this.intentosPaymentControl = false
    this.amountExceeded = false
    this.importeNeto = 0
    this.commission = 0
    this.iva = 0
    this.limpiarInput()
    this.internationalPaymentForm.get('date').clearValidators();
    this.internationalPaymentForm.get('date').updateValueAndValidity();
    this.internationalPaymentForm.reset()
    this.validateSubmitButton()
    this.schedulePaymentMethod()
  }

  showOperationResume() {
    this.internationalOperationSummaryService.open({
      amount: "$ 200 MXP",
      receiver: "alias - Ruben gallardo",
      bank: "BBVA",
      account: "45687987987",
      commission: "$ 0.00 MXP"
    })
  }

  loadersTest() {
    this.loadingContracts = true
    this.loadingBalances = true
    setTimeout(() => {
      this.loadingContracts = false
      this.loadingBalances = false
    }, 1500)
  }

  filterNames(event: any) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < (this.receivers as any[]).length; i++) {
      let name = (this.receivers as any[])[i];
      if (name.personName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(name);
      }
    }

    this.filteredNames = filtered;
  }

  fillInputReceiver() {
    this.currencySelected = this.currenciesByContractId.find((x: any) => {
      return x.cveCurrency === this.internationalPaymentForm.getRawValue().receiverSelected?.currency;
    });
    const receiverInfo: any = this.internationalPaymentForm.getRawValue().receiverSelected
    this.calculateTotal()
    this.inputReceiverValue = `<strong>Destinatario</strong>: ${receiverInfo?.identificationName} - ${receiverInfo?.personName} - <strong>${receiverInfo?.descriptionCurrency}</strong> - ${receiverInfo?.comment} ${this.ocultarNumeros(receiverInfo?.beneficiaryAccount)}`
    this.titleReceiver = this.inputReceiverValue.replace(/<strong>/g, "").replace(/<\/strong>/g, "")

  }

  public ocultarNumeros(numeroCompleto: string): string {
    const longitud = numeroCompleto.length;
    const ultimosCuatroDigitos = numeroCompleto.substring(longitud - 4);
    const asteriscos = '*'.repeat(longitud - 4);
    return asteriscos + ultimosCuatroDigitos;
  }

  getCurrencySymbol(): string | undefined {
    const currency = worldCurrencies.find(c => {
      return c.currency === this.internationalPaymentForm.getRawValue()?.receiverSelected?.currency
    })
    return currency?.symbol
  }

  calculateTotal() {
    this.getCurrencySymbol()
    const amountInput = this.internationalPaymentForm.getRawValue()?.amount
    const balance = this.currencySelected?.balance.replace(/,/g, '')
    const parsedBalance = parseFloat(balance)
    const calculation: any = (parsedBalance - amountInput) < 0 ? "Saldo insuficiente" : (parsedBalance - amountInput).toFixed(3) + ` ${this.currencySelected?.cveCurrency}`
    this.amountExceeded = calculation == "Saldo insuficiente" ? true : false
    return isNaN(balance) || !calculation ? balance : calculation
  }

  isHoveredClass(currency: any): boolean | string {
    const receiverSelectedCurrency = this.internationalPaymentForm.getRawValue()?.receiverSelected?.currency;
    const balance = currency.balance.toString().replace(/\./g, '');
    return (
      currency.cveCurrency === receiverSelectedCurrency &&
      this.inputReceiverValue &&
      Number(balance) > 0
    );
  }

  isBalanceNegative(currency: any): boolean | string {
    const receiverSelectedCurrency = this.internationalPaymentForm.getRawValue()?.receiverSelected?.currency;
    const balance = currency.balance.toString().replace(/\./g, '');
    return (
      currency.cveCurrency === receiverSelectedCurrency &&
      this.inputReceiverValue &&
      Number(balance) <= 0
    );
  }

  schedulePaymentMethod() {
    const switchLabel = document.querySelector('.switch-label') as HTMLElement;
    const switchHandle = document.querySelector('.switch-handle') as HTMLElement;
    const yesLabel = document.querySelector('#yesLabel') as HTMLElement;
    const noLabel = document.querySelector('#noLabel') as HTMLElement;

    if (this.internationalPaymentForm.getRawValue()?.date || this.internationalPaymentForm.getRawValue()?.date !== "") {
      this.internationalPaymentForm.patchValue({
        date: ""
      })
    }
    if (this.internationalPaymentForm.getRawValue()?.schedulePayment) {
      yesLabel.textContent = 'Si'
      noLabel.textContent = ''
      switchLabel.style.backgroundColor = '#0098DD';
      switchHandle.style.transform = 'translateX(30px)';
    } else {
      noLabel.textContent = 'No'
      yesLabel.textContent = ''
      switchLabel.style.backgroundColor = '#ccc';
      switchHandle.style.transform = 'translateX(0)';
    }
  }

  formattingDate() {
    const dateSelected = new Date(this.internationalPaymentForm.getRawValue()?.date)
    this.internationalPaymentForm.patchValue({
      date: moment(dateSelected).format("DD/MM/YYYY")
    })
  }

  validateSubmitButton() {
    if (this.internationalPaymentForm.getRawValue()?.schedulePayment) {
      this.internationalPaymentForm.get("date")?.setValidators([Validators.required])
      this.internationalPaymentForm.get("date")?.updateValueAndValidity()
    } else {
      this.internationalPaymentForm.get("date")?.clearValidators()
      this.internationalPaymentForm.get("date")?.updateValueAndValidity()
    }
    console.log(this.internationalPaymentForm?.valid, !this.amountExceeded, this.internationalPaymentForm.getRawValue()?.amount > 0)
    if (this.internationalPaymentForm?.valid && !this.amountExceeded && this.internationalPaymentForm.getRawValue()?.amount > 0) {
      return false
    } else if (this.internationalPaymentForm?.valid && this.amountExceeded && this.internationalPaymentForm.getRawValue()?.amount > 0 && this.internationalPaymentForm.getRawValue()?.date !== "") {
      return false
    } else {
      return true
    }
  }
}
